import React from "react";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner
} from "reactstrap";

const EditMerchantModal = ({
  editModal,
  edittoggle,
  handleUpdateRestaurant,
  handleInputChange,
  formData,
  isLoading
}) => {
  const isFormValid =
    formData?.name?.trim() &&
    formData?.location?.trim() &&
    formData?.status &&
    formData?.language;

  return (
    <div>
      <Modal isOpen={editModal} toggle={edittoggle}>
        <ModalHeader toggle={edittoggle}>Edit Merchant Details</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleUpdateRestaurant}>
            <Row>
              <Col>
                <FormGroup>
                  <Label for="name">Merchant Name</Label>
                  <Input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Enter name"
                    value={formData.name}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="location">Location</Label>
                  <Input
                    type="text"
                    name="location"
                    id="location"
                    placeholder="Enter location"
                    value={formData.location}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col>
                <FormGroup>
                  <Label for="status">Status</Label>
                  <Input
                    type="select"
                    name="status"
                    id="status"
                    value={formData.status}
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>
                      Select Status
                    </option>
                    <option value="Active">Active</option>
                    <option value="InActive">InActive</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="language">Language</Label>
                  <Input
                    type="select"
                    name="language"
                    id="language"
                    value={formData.language}
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>
                      Select Language
                    </option>
                    <option value="en">English</option>
                    <option value="ru">Russian</option>
                    <option value="fr">French</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <div className="d-flex justify-content-end">
              <Button color="primary" disabled={isLoading || !isFormValid}>
                {isLoading ? <Spinner size="sm" /> : "Update"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default EditMerchantModal;
